const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;
const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const ANTHROPIC_API_KEY = process.env.REACT_APP_ANTHROPIC_API_KEY;

// Property ROI context prompt
const PROPERTY_ROI_SYSTEM_PROMPT = `You are a knowledgeable real estate investment advisor specializing in property ROI analysis. You help users understand:

- Property investment fundamentals
- ROI calculations and metrics
- Market analysis and trends
- Investment strategies and risks
- Property valuation methods
- Cash flow analysis
- Tax implications of real estate investments

Keep responses conversational, helpful, and focused on practical advice. When discussing specific properties, refer to the property data provided in the context. Always consider the user's investment goals and risk tolerance.`;

export const claudeService = {
  async sendMessage(message, propertyContext = null, userId = null) {
    try {
      // Build context with property data if available
      let contextMessage = '';
      if (propertyContext) {
        contextMessage = `\n\nCurrent Property Context:
- Address: ${propertyContext.address || 'Not specified'}
- Purchase Price: $${propertyContext.purchasePrice || 'Not specified'}
- Down Payment: $${propertyContext.downPayment || 'Not specified'}
- Monthly Rent: $${propertyContext.monthlyRent || 'Not specified'}
- Property Tax: $${propertyContext.propertyTax || 'Not specified'}
- Insurance: $${propertyContext.insurance || 'Not specified'}
- ROI: ${propertyContext.roi || 'Not calculated'}%
- Cash Flow: $${propertyContext.cashFlow || 'Not calculated'}/month

Please consider this property data when providing advice.`;
      }

      const userMessage = message + contextMessage;

      const requestBody = {
        message: userMessage,
        systemPrompt: PROPERTY_ROI_SYSTEM_PROMPT,
        userId: userId
      };

      // Debug: Sending request to chat API

      // Call the real chat endpoint
      const response = await fetch(`${API_BASE_URL}/property_roi_chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': API_KEY
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Gateway error:', response.status, errorText);
        
        // Handle limit reached specifically
        if (response.status === 429) {
          try {
            const errorData = JSON.parse(errorText);
            throw new Error(errorData.error || 'Monthly chat limit reached');
          } catch (parseError) {
            throw new Error('Monthly chat limit reached. Upgrade for more messages!');
          }
        }
        
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      
      return {
        success: true,
        message: data.message || data.response || 'No response received',
        usage: data.usage
      };
    } catch (error) {
      console.error('Claude API error:', error);
      return {
        success: false,
        error: error.message || 'Failed to get response from Claude',
        message: 'Sorry, I encountered an error. Please try again.'
      };
    }
  },

  async sendMessageWithHistory(message, conversationHistory = [], propertyContext = null, userId = null) {
    try {
      // Build context with property data if available
      let contextMessage = '';
      if (propertyContext) {
        contextMessage = `\n\nCurrent Property Context:
- Address: ${propertyContext.address || 'Not specified'}
- Purchase Price: $${propertyContext.purchasePrice || 'Not specified'}
- Down Payment: $${propertyContext.downPayment || 'Not specified'}
- Monthly Rent: $${propertyContext.monthlyRent || 'Not specified'}
- Property Tax: $${propertyContext.propertyTax || 'Not specified'}
- Insurance: $${propertyContext.insurance || 'Not specified'}
- ROI: ${propertyContext.roi || 'Not calculated'}%
- Cash Flow: $${propertyContext.cashFlow || 'Not calculated'}/month`;
      }

      const userMessage = message + contextMessage;

      const requestBody = {
        message: userMessage,
        conversationHistory: conversationHistory,
        systemPrompt: PROPERTY_ROI_SYSTEM_PROMPT,
        userId: userId
      };

      // Debug: Sending request to chat API with conversation history

      // Call the real chat endpoint
      const response = await fetch(`${API_BASE_URL}/property_roi_chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': API_KEY
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Gateway error:', response.status, errorText);
        
        // Handle limit reached specifically
        if (response.status === 429) {
          try {
            const errorData = JSON.parse(errorText);
            throw new Error(errorData.error || 'Monthly chat limit reached');
          } catch (parseError) {
            throw new Error('Monthly chat limit reached. Upgrade for more messages!');
          }
        }
        
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      
      return {
        success: true,
        message: data.message || data.response || 'No response received',
        usage: data.usage
      };
    } catch (error) {
      console.error('Claude API error:', error);
      return {
        success: false,
        error: error.message || 'Failed to get response from Claude',
        message: 'Sorry, I encountered an error. Please try again.'
      };
    }
  }
};